import axios from "axios";
import storeConfig from "../reducers/store";
import { AppState } from "../reducers";
import { loginUrl } from "../utils/applicationUtils";
const { store } = storeConfig;

const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

export const rootAPI = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL!.replace(
      "/coreapi/v5"
      , ""),
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

[API, rootAPI].forEach(api => {
  api.interceptors.request.use(config => {
    const { auth } = store.getState() as AppState;
    if (auth && auth.token && auth.token !== '') {
      config.headers.Authorization = `Bearer ${auth.token}`;
    }
    return config;
  });

  api.interceptors.response.use(
    response => response,
    error => {
      // Auth token invalid
      if (
        error.response &&
        (error.response.status === 403 || error.response.status === 401)
      ) {
        
        store.dispatch({ type: "CLEAR_AUTH" });
        window.location.href = '/';
      }
      return Promise.reject(error);
    }
  );
});

export const buildUrl = (
  baseUri: string,
  params?: { [param: string]: any }
) => {
  let url = `${baseUri}?`;

  if (params) {
    url = buildQueryString(url, params);
  }

  return url.replace(/(\?|&|\/)\s*$/, "");
};

export const buildQueryString = (
  uri: string,
  params: { [param: string]: any }
) => {
  return Object.keys(params).reduce((acc, param) => {
    acc += `${param}=${encodeURIComponent(params[param])}&`;
    return acc;
  }, uri);
};

export const throwServiceError = (error: any) => {
  // TODO: Add Bugsnag
  if (error.isAxiosError) {
    console.log("Axios Error: ", error.response.data);
    throw error.response.data;
  } else {
     console.log("Error: ", { message: error.message });
    throw { message: error.message };
  }
};

export default API;
